import { all } from 'redux-saga/effects';

import expiryWatcher from './expirydocumentsaga';

export default function* rootSaga(action) {
    console.log("Saga")
    yield all([expiryWatcher(action)]);
}
